const state = {
  jobOffersListIds: localStorage.getItem('jobOffersListIds') ? localStorage.getItem('jobOffersListIds').split(',') : [],
};

const getters = {
  getJobOffersList: state => {
    return state.jobOffersListIds;
  }
};

const actions = {
  setJobOffersList(context, jobOffersListIds) {
    context.commit('setJobOffersListHandler', jobOffersListIds)
  }
};

const mutations = {
  setJobOffersListHandler(state, jobOffersListIds) {
    state.jobOffersListIds = jobOffersListIds;
    localStorage.setItem('jobOffersListIds', jobOffersListIds)
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/jobOffersList/index.js